<template>
  <div class="col-md-4 col-sm-6 d-flex">
    <div class="card">
      <div class="card-header mb-4">
        <div class="row align-items-center">
          <div class="col-6">
            <h5 class="card-title">Invited User</h5>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="invite-user-list">
          <ul>
            <li v-for="record in Indexinvite" :key="record.id">
              <div class="table-avatar">
                <a href="javascript:;"
                  ><img
                    class="avatar avatar-sm me-2 avatar-img rounded-circle"
                    :src="require(`@/assets/admin_img/profiles/${record.Image}`)"
                    alt="User Image"
                  />{{ record.Name }}</a
                >
              </div>
              <div class="invite-check-user">
                <span class="check-user"
                  ><a href="javascript:;"><i class="bx bx-check"></i></a
                ></span>
                <span class="uncheck-user"
                  ><a href="javascript:;"><i class="bx bx-x"></i></a
                ></span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Indexinvite from "@/assets/json/admin/indexinvite.json";
export default {
  data() {
    return {
      Indexinvite: Indexinvite,
    };
  },
};
</script>
